import Axios from "axios";
var CompanyService = (function () {
    function CompanyService() {
    }
    CompanyService.prototype.getCompanyTypeList = function () {
        return Axios.get("basicapi/company_type");
    };
    CompanyService.prototype.getTaxinvoicetype = function () {
        return Axios.get("basicapi/taxinvoicetype");
    };
    CompanyService.prototype.getSettlementList = function () {
        return Axios.get("basicapi/settlement_list");
    };
    CompanyService.prototype.save = function (data) {
        return Axios.post("supplierclientapi/companyinfo/save", data);
    };
    CompanyService.prototype.getDetail = function () {
        return Axios.get("supplierclientapi/companyinfo/show");
    };
    CompanyService.createInstance = function () {
        CompanyService.getInstance();
    };
    CompanyService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return CompanyService;
}());
export default CompanyService;
